export default __webpack_public_path__ + "static/affiliate-program-Intro-01c6edfa76af82497456f3aa7937fd39.svg";